
import { Suspense, lazy, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";

// Lazy load non-critical components
const TopMentors = lazy(() => import("@/components/TopMentors"));
const Benefits = lazy(() => import("@/components/Benefits"));
const Footer = lazy(() => import("@/components/Footer"));

// Simple loading component for Suspense fallback
const SectionLoading = () => (
  <div className="w-full py-24 flex justify-center">
    <div className="w-10 h-10 border-4 border-emu-blue border-t-transparent rounded-full animate-spin"></div>
  </div>
);

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "EMU Mentoring | Professional Mentorship Platform";
  }, []);

  useEffect(() => {
    // Check if user is coming from a password reset email
    const urlHash = window.location.hash;
    const urlParams = new URLSearchParams(window.location.search);
    
    // Look for recovery flow indicators in URL
    const hasRecoveryToken = urlHash.includes('access_token=') && urlHash.includes('type=recovery');
    const isRecoveryFlow = urlParams.get('type') === 'recovery';
    
    if (hasRecoveryToken || isRecoveryFlow) {
      console.log("Password reset flow detected, redirecting to reset password page");
      // Use React Router navigation and preserve URL parameters and hash for the reset page
      navigate('/reset-password' + window.location.search + window.location.hash);
    }
  }, [navigate]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      
      <Suspense fallback={<SectionLoading />}>
        <TopMentors />
      </Suspense>
      
      <Suspense fallback={<SectionLoading />}>
        <Benefits />
      </Suspense>
      
      {/* Join EMU Today button - centered */}
      <div className="bg-white py-16 text-center">
        <Button 
          variant="action" 
          size="lg" 
          className="text-xl font-bold px-12 py-8 shadow-lg hover:shadow-xl transition-all mx-auto"
          asChild
        >
          <Link to="/sign-up">Join EMU Today</Link>
        </Button>
      </div>
      
      <Suspense fallback={<SectionLoading />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
